import { Drawer, Tabs } from "antd";
import { isNil } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import DispatchLogs from "./DispatchLogs";
import DispatcherSettings from "./DispatcherSettings";

export const TABS = { SETTINGS: "settings", LOGS: "logs" };

const DRAWER_WIDTH = 760;

const DispatcherDrawer = ({ dispatcher, tab, names, onClose, onSaved }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DISPATCHER);
  const settings = (
    <DispatcherSettings
      dispatcher={dispatcher}
      names={names}
      onCancel={onClose}
      onSaved={onSaved}
    />
  );

  return (
    <Drawer
      open
      width={DRAWER_WIDTH}
      title={isNil(dispatcher) ? t("CREATE") : dispatcher.name}
      onClose={onClose}
      destroyOnClose
    >
      {isNil(dispatcher) ? (
        settings
      ) : (
        <Tabs
          defaultActiveKey={tab}
          items={[
            {
              key: TABS.SETTINGS,
              label: t("TABS.SETTINGS"),
              children: settings,
            },
            {
              key: TABS.LOGS,
              label: t("TABS.LOGS"),
              children: <DispatchLogs dispatcher={dispatcher} />,
            },
          ]}
        />
      )}
    </Drawer>
  );
};

export default DispatcherDrawer;
